import { SvgIcon, SvgIconProps } from "@mui/material";

type Props = SvgIconProps;

export function Refresh(props: Props) {
  const colorValue = props.fill ?? (props.sx as any)?.color ?? "#01ADEF";
  return (
    <SvgIcon {...props} sx={{ ...props.sx, color: colorValue }}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M10.5 0C16.299 0 21 4.70101 21 10.5C21 16.299 16.299 21 10.5 21C4.70101 21 0 16.299 0 10.5C0 4.70101 4.70101 0 10.5 0ZM11.9492 3.43066L12.5537 4.88672C11.1262 4.29794 9.49374 4.23817 7.97266 4.87012C4.81226 6.18366 3.44038 9.90589 4.7793 13.1279C6.11828 16.3499 9.72421 18.0037 12.8848 16.6904C15.2269 15.7169 16.5912 13.4078 16.5898 10.9775H15.6895L14.79 10.9785C14.791 12.7516 13.8015 14.3591 12.1943 15.0273C10.0332 15.9254 7.43467 14.8244 6.44238 12.4365C5.45022 10.0487 6.503 7.43026 8.66406 6.53223C9.79093 6.0642 11.0257 6.13791 12.0986 6.65332L10.6094 7.25293L11.2812 8.92285L15.4785 7.2334L13.6113 2.73828L11.9492 3.43066Z" fill="currentColor"/>
      </svg>
    </SvgIcon>
  );
}
